export const shutoffOptions = [
  { label: 'Open', value: 1 },
  { label: 'Closed', value: 0 },
  { label: 'Unknown', value: null },
];

export const yesNoOptions = [
  { label: 'Yes', value: 1 },
  { label: 'No', value: 0 },
];
